import { render, staticRenderFns } from "./CabinetModule.vue?vue&type=template&id=0e097930&"
import script from "./CabinetModule.vue?vue&type=script&lang=js&"
export * from "./CabinetModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports